import { render, staticRenderFns } from "./GlobalSearchFilter.vue?vue&type=template&id=0b56c616&"
import script from "./GlobalSearchFilter.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports